export const footer = {
  footerTitleGame: "The Best Games",
  footerTitleGameCasino: "Casino",
  footerTitleGameLottery: "Lottery",
  footerTitleGameGames: "Mini games",
  footerTitleSports: "Sports",
  footerTitleGameSlots: "Slots",
  footerTitleGameHorses: "Horse Racing",
  footerTitleGameMesa: "Table Games",
  footerTitleGameMinigame: "Minigames",
  footerTitleLiga: "Winning Leagues",
  footerTitleLigaEsports: "E-Sports",
  footerTitleLigaLeague: "The League",
  footerTitleLigaFootball: "UEFA Champions League",
  footerTitleSupport: "Support",
  footerTitleHelp: "Help Center",
  footerTitleTerms: "Terms and Conditions",
  footerTitleSocial: "Follow us",
  footerTitleApp: "Download our App",
  footerTitlePromotions: "Promotions",
  footerTitleResponsibleGambling: "Gamble responsibly. Only for 18+.",
  footerTitleSafeGame: "Everything for a safer game",
};
